export const getEndpoint = (): string => {
  return process.env.MAPS_ENDPOINT as string;
};
export const CustomerLoginUrl = "/login/customer";
export const VendorLoginUrl = "/login/vendor";
export const OpmLoginUrl = "/login/opm";
export const AttachmentEndpoint = getEndpoint() + "/attachment/";
